import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { OShotHero } from '../components/o-shot/OShotHero';
export function OShotPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2583">
      <Navigation data-id="element-2584" />
      <main data-id="element-2585">
        <OShotHero data-id="element-2586" />
      </main>
      <Footer data-id="element-2587" />
    </div>;
}